<div class="modal-header">
    <h4 class="modal-title">{{'lessonObservation_selectTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm" [class.was-validated]="isSubmitted">
        <section class="block-em">
            <div class="row">
                <div class="form-field required col-lg-4 col-sm-6">
                    <label class="form-label">{{'lessonObservation_lblDate' | translate}}</label>
                    <app-date [(ngModel)]="payload.Date"
                              [required]="true"
                              name="date"></app-date>
                </div>

                <div class="form-field col-lg-6">
                    <label class="form-label">{{'lessonObservation_lblType' | translate}}</label>
                    <app-select [(ngModel)]="payload.TypeId"
                                [options]="types"
                                [displayProperty]="'Name'"
                                [valueProperty]="'Id'"
                                name="type">
                    </app-select>
                </div>

                <div class="form-field d-flex align-items-end col-lg-2">
                    <button class="btn btn-outline" (click)="search()" type="button" [disabled]="isLoading || (isSubmitted && !form.valid)">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isLoading"></span>
                        {{'search' | translate}}
                    </button>
                </div>
            </div>
        </section>

        <div class="mb-1" *ngIf="events.length">
            <div class="row">
                <div class="form-field col-lg-6">
                    <label class="form-label">{{'lessonObservation_lblSubject' | translate}}</label>
                    <app-select [(ngModel)]="filterSubject"
                                [options]="subjects"
                                [displayProperty]="'display'"
                                [filter]="filterOptionFilterFn"
                                (selectionChange)="filter()"
                                name="filterSubject">
                        <ng-template #optionTemplate let-option>
                            <div><strong>{{option.code}}</strong></div>
                            <div>{{option.name}}</div>
                        </ng-template>
                    </app-select>
                </div>

                <div class="form-field col-lg-3 col-md-6">
                    <label class="form-label">{{'lessonObservation_lblTimeFrom' | translate}}</label>
                    <input class="form-control" #timeFromInput="ngModel" [(ngModel)]="filterTimeFrom" name="tomeFrom" maxlength="5" [pattern]="timePattern"
                           (input)="timeFromInput.valid && filter()">
                </div>

                <div class="form-field col-lg-3 col-md-6">
                    <label class="form-label">{{'lessonObservation_lblTimeTo' | translate}}</label>
                    <input class="form-control" #timeToInput="ngModel" [(ngModel)]="filterTimeTo" name="tomeTo" maxlength="5" [pattern]="timePattern"
                           (input)="timeToInput.valid && filter()">
                </div>
            </div>

            <div class="row">
                <div class="form-field col-lg-6">
                    <label class="form-label">{{'lessonObservation_lblTeacher' | translate}}</label>
                    <app-select [(ngModel)]="filterTeacher"
                                [options]="teachers"
                                [displayProperty]="'display'"
                                [filter]="filterOptionFilterFn"
                                (selectionChange)="filter()"
                                name="filterTeacher">
                    </app-select>
                </div>

                <div class="form-field col-lg-6">
                    <label class="form-label">{{'lessonObservation_lblLocation' | translate}}</label>
                    <app-select [(ngModel)]="filterLocation"
                                [options]="locations"
                                [displayProperty]="'display'"
                                [filter]="filterOptionFilterFn"
                                (selectionChange)="filter()"
                                name="filterLocation">
                    </app-select>
                </div>
            </div>
        </div>

        <app-table [rows]="events" [columns]="columns" [pageSize]="5" *ngIf="isFetched">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td>
                        <div class="text-top">{{row.SubjectCode}}</div>
                        <div>{{row.SubjectName}}</div>
                        <div class="hidden-lg-up mt-1">
                            <i class="fi fi-rs-calendar-clock"></i>
                            {{row.Date | appDate}} ({{row.TimeFrom | appTime}} - {{row.TimeTo | appTime}})
                        </div>
                        <div class="hidden-lg-up">
                            <i class="fi fi-rs-marker"></i>
                            {{row.Location}}
                        </div>
                    </td>
                    <td class="text-nowrap hidden-md-down">
                        <div>{{row.Date | appDate}}</div>
                        <div class="text-sm">{{row.TimeFrom | appTime}} - {{row.TimeTo | appTime}}</div>
                    </td>
                    <td class="hidden-md-down">{{row.Location}}</td>
                    <td>
                        <div class="table-actions">
                            <button type="button" class="btn btn-outline btn-icon" (click)="select(row)">
                                <i class="fi fi-rs-angle-right"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isLoading">{{'cancel' | translate}}</button>
</div>
